import { cssSpacing, dialog, rootStyle } from "../../styles/index.js";
import styled from "../../styled-components.js";
export var Dialog = styled.div.attrs({
  role: 'dialog'
}).withConfig({
  displayName: "Dialog",
  componentId: "sc-18qzfns-0"
})(["", ";", ";padding-block-start:", ";inline-size:335px;overflow-wrap:break-word;"], rootStyle(), function (props) {
  return dialog({
    colorSet: props.$colorSet
  });
}, cssSpacing('base', '16px'));